import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { InteraccionRedesSociales } from '../../../../interfaces/interaccion-redes-sociales';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';

@Component({
  selector: 'app-validacion-de-documento',
  templateUrl: './validacion-de-documento.component.html',
  styleUrls: ['./validacion-de-documento.component.scss'],
})
export class ValidacionDeDocumentoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['nombre', 'valido', 'comentario'];
  dataSource = new MatTableDataSource<any>();
  submitFile = false;
  tableValues: any[] = [];
  submit = false;
  form: FormGroup;
  formTable: FormGroup;
  caso;
  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  worker;
  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public _caso: CasoTareaService,
    public _snackbar: MatSnackBar,
    public taskCaseService: TaskCaseService,
    public _rolesPermisosService: RolesPermisosService,
    public _notificacion: NotificacionService,
    private caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}

  ngOnInit(): void {
    // this._caso.getById(this.data.task.idCaso).subscribe((response) => {
    //   this.caso = response;
    // });
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : null;
    if (values) {
      this.tableValues = values.documentos;
    }
    this.initializeTable();

    this.form = this.fb.group({
      is: [values ? values.is : '', [Validators.required]],
      nombre: [values ? values.nombre : ''],
      nm: [values ? values.nm : ''],
      contactar_entidad_emisora: [
        values ? values.contactar_entidad_emisora : false,
      ],
      comision_especialista: [values ? values.comision_especialista : false],
      entreaga_comunucacion_interna: [
        values ? values.entreaga_comunucacion_interna : false,
      ],
      respuesta_entidad: [values ? values.respuesta_entidad : false],
      // documento_valido: [values ? values.documento_valido : ''],
      fecha1: [values ? values.fecha1 : ''],
      fecha2: [values ? values.fecha2 : ''],
      fecha3: [values ? values.fecha3 : ''],
      fecha4: [values ? values.fecha4 : ''],
      documentos: [values ? values.documentos : []],
    });
    this.formTable = this.fb.group({
      nombre: ['', [Validators.required]],
      valido: ['', [Validators.required]],
      comentario: ['', [Validators.required]],
    });
    if (values) {
      if ((values.is = 'si')) {
        this.form.controls.nombre.setValidators([Validators.required]);
        this.form.controls.nm.setValidators([Validators.required]);
      }
    }
  }
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    // if (this.formTable.value.valido == 'No') {
    //   this._rolesPermisosService
    //     .takeUser(['Administrador Casos de Asuntos Externos'])
    //     .subscribe((response) => {
    //       let users;
    //       users = response.payload.data;
    //       for (let user of users) {
    //         this._notificacion
    //           .notificacionNoDocumentoValido(
    //             user.id_usuarios,
    //             this.caso.numero_caso
    //           )
    //           .toPromise();
    //       }
    //     });
    // }
    this.tableValues.unshift(this.formTable.value);
    this.form.value.documentos = this.tableValues;
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.form.value })
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }
  initializeTable() {
    this.dataSource = new MatTableDataSource<InteraccionRedesSociales>(
      this.tableValues
    );
    this.dataSource.paginator = this.paginator;
    this.submit = false;
    this.submitFile = false;
  }

  changeIsWorker(value) {
    if (value == true) {
      this.form.controls.nombre.setValidators([Validators.required]);
      this.form.controls.nm.setValidators([Validators.required]);
    } else {
      // this.form.controls.nombre.setValidators([]);
      // this.form.controls.nm.setValidators([]);
      this.form.controls.nombre.clearValidators();
      this.form.controls.nm.clearValidators();
    }
    this.form.controls.nombre.updateValueAndValidity();
    this.form.controls.nm.updateValueAndValidity();
  }
  // remireAsuntosInternos(){
  //   this.caso.unidad = "Asuntos Internos"
  //   this.caso.tipo_caso = "Investigación de asuntos internos"
  //   this.caso.estado = "Por Asignar"
  //   this.caso.historial.push({
  //     usuario: `${sessionStorage.getItem("correo")}`,
  //     realizo:`Paso el caso a Asuntos Internos, Investigacion de asuntos internos`,
  //     date: new Date()
  //   })
  //   this._caso.put(this.caso._id,this.caso).subscribe((response)=>{
  //     this._snackbar.open("Caso remitido a Asuntos Internos","x")
  //   })
  // }

  // finalizar(){
  //   this._caso.getById(this.data.task.idCaso).subscribe((response)=>{
  //     this.caso = response
  //   })
  //   if(this.caso.estado != "Finalizado"){
  //     this.caso.estado = "Finalizado"
  //     this.caso.historial.push({
  //       usuario: `${sessionStorage.getItem("correo")}`,
  //       realizo:`Paso este caso a Finalizado`,
  //       date: new Date()
  //     })
  //     this._caso.put(this.caso._id,this.caso).subscribe((response)=>{
  //       this._snackbar.open("Caso enviado a Finalizado","x")
  //     })
  //   }
  // }
}
